/* eslint-disable no-param-reassign */

import { createAsyncThunk, createSlice, SerializedError } from '@reduxjs/toolkit'
import { ApplicationList, ApplicationListResponse, getApplicationList } from '../api/registration'
import { RootState } from './rootReducer'

interface State {
  applications: ApplicationList[] | null
  totalCount: number
  totalPages: number
  currentLimit: number
  currentPage: number

  loading: 'idle' | 'pending'
  error: SerializedError | null
}

const initialState: State = {
  applications: null,
  totalCount: 0,
  totalPages: 0,
  currentLimit: 0,
  currentPage: 0,
  loading: 'idle',
  error: null,
}

export const fetchApplicationList = createAsyncThunk<
  ApplicationListResponse,
  {
    page: number
    limit: number
  },
  {
    state: RootState
  }
>('applications/fetchApplicationList', async ({ page, limit }) => {
  const response = await getApplicationList(limit, page)
  return response
})

const slice = createSlice({
  name: 'applications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchApplicationList.pending, (state) => {
      state.applications = null
      state.totalCount = 0
      state.totalPages = 0
      state.currentLimit = 0
      state.currentPage = 0
      state.error = null
      state.loading = 'pending'
    })
    builder.addCase(fetchApplicationList.fulfilled, (state, { payload }) => {
      state.applications = payload.applications
      state.totalCount = payload.totalCount
      state.totalPages = payload.totalPages
      state.currentLimit = payload.currentLimit
      state.currentPage = payload.currentPage
      state.loading = 'idle'
    })
    builder.addCase(fetchApplicationList.rejected, (state, action) => {
      state.error = action.error
      state.loading = 'idle'
    })
  },
})

// export const { } = slice.actions

export default slice.reducer
